import React, { Component } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import $ from "jquery";


class Salons extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saloncode: "",
            ps: null,
        }
    }

    componentDidMount = () => {
        document.querySelector(".settings").style.display = "none";
        this.height();
        const ps = new PerfectScrollbar('.salons-container-body', {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
        });
        this.setState((prevState) => {
            prevState.ps = ps;
            return prevState;
        });
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    componentDidUpdate = () => {
        this.height();
        this.state.ps.update();
    }

    height = () => {
        let totalHeight = $(window).height();
        let heightHeader = $(".header").outerHeight();
        document.querySelector(".salons").style.height = (totalHeight - heightHeader) + "px";
        let heightSalonsBody = 
            totalHeight - 
            heightHeader - 
            55; //height salons-container-header
        document.querySelector(".salons-container-body").style.height = (0.8 * heightSalonsBody) + "px";
    }
    
    resize = () => {
        this.height();
    }

    onClickSalon = (salon) => {
        this.props.setSalon(salon["salon"]);
    }

    renderSalons = () => {
        let salons = [];
        this.props.setup["salons"].forEach((salon) => {
            let key = this.uniqueid();
            salons.push(
                <div className="card mb-2" key={key} onClick={() => this.onClickSalon(salon)}>
                    <div className="card-content">
                        <p className="salons-name">
                            {salon["naam"]}
                        </p>
                        <p className="salons-address">
                            {salon["adres"]}
                        </p>
                    </div>
                </div>
            );
        });
        return salons;
    }

    uniqueid = () => {
        return Math.random().toString(36).replace(/[^a-z]+/g, '');
    }

    render() {
        return (
            <div className="salons">
                <div className="salons-container">
                    <div className="salons-container-header">
                        Kies uw Salon
                    </div>
                    <div className="salons-container-body">
                        {this.renderSalons()}
                    </div>  
                </div>
            </div>
        );
    }
}

export default Salons;
